import { createAction } from '@reduxjs/toolkit';
import { IUser, userDto } from '@qwealth/qdata';

import { deleteUser as deleteUserRequest, fetchUsers, patchUser, postUser } from 'data/data-layer/users';
import { AppThunkAction } from '../store';

const PUT_USERS = 'PUT_USERS';
const UPDATE_USER = 'UPDATE_USER';
const CREATE_USER = 'CREATE_USER';
const REMOVE_USER = 'REMOVE_USER';
const RESET_USERS = 'RESET_USERS';
const LOADING_USERS = 'LOADING_USERS';

export const putUsers = createAction<IUser[]>(PUT_USERS);
export const updateUser = createAction<IUser>(UPDATE_USER);
export const createUser = createAction<IUser>(CREATE_USER);
export const removeUser = createAction<string>(REMOVE_USER);
export const resetUsers = createAction(RESET_USERS);
export const setLoading = createAction<boolean>(LOADING_USERS);

export const loadUsers =
  (params = {}): AppThunkAction =>
  async dispatch => {
    dispatch(setLoading(true));
    const users = await fetchUsers(params, dispatch);
    if (users) {
      dispatch(putUsers(users));
    }
    dispatch(setLoading(false));
  };

export const saveUser =
  (user: IUser): AppThunkAction<Promise<void>> =>
  async dispatch => {
    const { freshdeskID, iaCodes, insuranceCodes, partnerID, QID, ...apiUser } = user;
    const payload: userDto = {
      ...apiUser,
      IAcodes: iaCodes ? iaCodes.join(',') : '',
      insuranceCodes: insuranceCodes ? insuranceCodes.join(',') : '',
      freshdeskID: freshdeskID || '',
      partnerID: partnerID || 0,
      QID: QID || '',
    };

    const savedUser = payload.id ? await patchUser(payload, dispatch) : await postUser(payload, dispatch);

    if (payload.id && savedUser) {
      dispatch(updateUser(savedUser));
    } else if (savedUser) {
      dispatch(createUser(savedUser));
    }
  };

export const deleteUser =
  (id: string): AppThunkAction<Promise<void>> =>
  async dispatch => {
    const deletedId = await deleteUserRequest(id, dispatch);
    if (deletedId) {
      dispatch(removeUser(deletedId));
    }
  };
